import repository from '@/utils/repository';

const common_resource = '/move';

export default {
    searchGroupInfo: (data) => {
        return repository.post(`${common_resource}/postCommonMst006Info`, {
            ...data
        });
    }
};
